import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {TraceComponent} from './betontrace/trace/trace.component';

const routes: Routes = [
  {
    path: '',
    component: TraceComponent,
    children: [
      {
        path: ':klantnaam',
        component: TraceComponent
      },
      {
        path: ':klantnaam/:traceCode',
        component: TraceComponent
      },
      {
        path: ':klantnaam/:traceCode/:tracePin',
        component: TraceComponent
      }
    ]
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
